import { combineReducers } from 'redux';
import auth from './auth/auth.reducer';
import survey from './survey/survey.reducer';
import users from './survey/users.reducer';
import common from './common';
import { ProjectReducer } from '../participant/actions/ProjectActions';
import { UserReducer } from '../actions/UserActions';
import { AuthReducer } from '../auth/actions/AuthActions';
import { QuestionnaireReducer } from '../participant/actions/QuestionnaireActions';
import AdminUsersSlice from '../admin/slices/AdminUsersSlice';
import IAdminReducer from '../admin/types/IAdminReducer';
import AdminCustomerSlice from '../admin/slices/AdminCustomerSlice';
import AdminDashboardSlice from '../admin/slices/AdminDashboardSlice';
import ICommonReducer from '../common/types/ICommonReducer';
import ParticipantReducer from '../participant/types/ParticipantReducer';
import DashboardSlice from '../participant/slices/DashboardSlice';
import AdminProjectSlice from '../admin/slices/AdminProjectSlice';
import AdminInviteSlice from '../admin/slices/AdminInviteSlice';
import Admin360QuestionnaireSlice from '../admin/slices/Admin360QuestionnaireSlice';
import Admin360ScaleSlice from '../admin/slices/Admin360ScaleSlice';
import Admin360GroupSlice from '../admin/slices/Admin360GroupSlice';
import Admin360ParticipantSlice from '../admin/slices/Admin360ParticipantSlice';
import AdminSortingCriteriaSlice from '../admin/slices/AdminSortingCriteriaSlice';
import AdminReportsSlice from '../admin/slices/AdminReportsSlice';
import AdminProjectAdminsSlice from '../admin/slices/AdminProjectAdminsSlice';
import AdminJobMatchSlice from '../admin/slices/AdminJobMatchSlice';

export const rootReducer = combineReducers({
    auth,
    survey,
    users,
    common,
    participant: combineReducers({
        project: ProjectReducer,
        dashboard: DashboardSlice.reducer,
    }),
    auth2: AuthReducer,
    user: UserReducer,
    questionnaire: QuestionnaireReducer,
    admin: combineReducers({
        users: AdminUsersSlice.reducer,
        customer: AdminCustomerSlice.reducer,
        dashboard: AdminDashboardSlice.reducer,
        project: AdminProjectSlice.reducer,
        invite: AdminInviteSlice.reducer,
        360: combineReducers({
            scales: Admin360ScaleSlice.reducer,
            questionnaire: Admin360QuestionnaireSlice.reducer,
            groups: Admin360GroupSlice.reducer,
            participant: Admin360ParticipantSlice.reducer,
        }),
        criteria: AdminSortingCriteriaSlice.reducer,
        reports: AdminReportsSlice.reducer,
        admins: AdminProjectAdminsSlice.reducer,
        jobMatch: AdminJobMatchSlice.reducer,
    }),
});

export type AppState = any & {
    admin: IAdminReducer;
    common: ICommonReducer;
    participant: ParticipantReducer;
};
